import { send } from 'server';

import * as Types from './types';

export const checkIfUsernameIsAvailable = ({
    userName,
    casinoName,
    token
}: Types.ICheckIfUsernameIsAvailableRequest):
    Types.ICheckIfUsernameIsAvailableResponse => send({
    ID: 31003,
    description: 'Checks if userName is available',
    responses: [31004, 33007],
    userName,
    casinoName,
    ...token && { token }
});
